/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IHosportsTaggedImageData } from './hosports-tagged-image.data';
import { IHosportsTaggedImageProps } from './hosports-tagged-image.props.autogenerated';

export interface IHosportsTaggedImageViewProps extends IHosportsTaggedImageProps<IHosportsTaggedImageData> {

}

/**
 *
 * HosportsTaggedImage component
 * @extends {React.PureComponent<IHosportsTaggedImageProps<IHosportsTaggedImageData>>}
 */
class HosportsTaggedImage extends React.PureComponent<IHosportsTaggedImageProps<IHosportsTaggedImageData>> {
    public render(): JSX.Element | null {

        return this.props.renderView(this.props);
    }
}

export default HosportsTaggedImage;
